/**
 * Подписи переклички героев (ISSUE-122, ISSUE-145): значок и название навыка над героем, перед обычной волной — плашка
 * «Волна N» и уровень у героев, которые его получили. Текст и значки — DOM, как весь HUD; время
 * задаёт CSS, поэтому кадр боя их не перерисовывает. Пауза боя ставит на паузу и подписи.
 */
import { heroIntroStore } from "../../app/hero-intro";
import { useStore } from "../../app/hooks";
import { appStore, isBattlePaused } from "../../app/store";
import { Icon, Plate } from "../kit";
import "./hero-intro.css";
import { SKILL_ICON } from "./HudView";
import type { HudKey, HudT } from "./messages";

export function HeroIntroPlates({ t }: { t: HudT }) {
  const intro = useStore(heroIntroStore, (s) => s);
  const paused = useStore(appStore, isBattlePaused);
  if (!intro || (intro.plates.length === 0 && !intro.wave)) return null;
  const big = intro.kind === "hero";
  return (
    <div class="kit hero-intro" data-testid="hero-intro" data-kind={intro.kind} data-paused={paused ? "1" : "0"}>
      {intro.wave && (
        <Plate
          key={`${intro.id}:wave`}
          class="hero-intro__wave"
          data-testid="hero-intro-wave"
          style={{ "--from": "0s", "--dur": `${intro.wave.seconds}s` }}
        >
          {t("hud.wave", { n: intro.wave.number })}
        </Plate>
      )}
      {intro.plates.map((p) => (
        <Plate
          key={`${intro.id}:${p.heroId}`}
          class="hero-intro__plate"
          data-testid={`hero-intro-${p.heroId}`}
          style={{
            "--x": `${p.x}px`,
            "--y": `${p.y}px`,
            "--from": `${p.from}s`,
            "--dur": `${p.to - p.from}s`,
          }}
        >
          <Icon name={SKILL_ICON[p.heroId]} size={big ? 38 : 30} />
          <span class="hero-intro__text">
            <small>{big ? t("hud.introNewHero") : t(`hud.heroName.${p.heroId}` as HudKey)}</small>
            <b>{p.level === undefined ? t(`hud.skill.${p.heroId}` as HudKey) : t("hud.introLevel", { n: p.level })}</b>
          </span>
        </Plate>
      ))}
    </div>
  );
}
